import type { FeedItem as FeedItemType } from '@whispers/sdk';

import { Button } from '../Button.js';
import { FeedItem } from './FeedItem.js';

type PageFeedItemProps = { item: Extract<FeedItemType, { type: 'page' }> };

export const PageFeedItem = ({ item }: PageFeedItemProps) => (
  <FeedItem label="New page" occurredAt={item.occurredAt}>
    <h2 className="text-lg font-medium text-text">{item.page.title}</h2>
    {item.page.excerpt && (
      <p className="mt-2 text-sm leading-6 text-text-secondary">{item.page.excerpt}</p>
    )}
    <Button
      href={`/${item.page.slug}`}
      variant="secondary"
      className="mt-5 w-full"
      aria-label={`Read ${item.page.title}`}
    >
      Read page
    </Button>
  </FeedItem>
);
